import conf from '../config/api.js';
import Vue from 'vue';
var moment = require('moment');
//var htmlEncode = require('js-htmlencode').htmlEncode;
var htmlDecode = require('js-htmlencode').htmlDecode;

//Fonction génération de toaster erreur
function toasterError(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

//fonction de récupération des fichier export je pilote
async function checkBeforeSubmit(source,id,securekey){
	try {
		var payload = {
			source: source,
			id: id,
			securekey: securekey
		}
    	let response = await requestApi({method: 'POST', url: '/api/checkBeforeSubmit?nocache=' + new Date().getTime(), params: {}, form: {payload}, headers: {'Content-Type': 'application/json'}})
		if(response.find){
			window.location.href = response.url
		}
	} catch (error) {
        if(error.response != undefined){
			toasterError(`Vérification impossible`,'Vérification')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
    }
}

//Fonction d'envoi des informations bancaires
async function sendAllInfos(source,id,securekey,form,fileList){
	try {
		var payload = {
			source: source,
			id: id,
			securekey: securekey,
			form: form
		}

		const formData = new FormData()
		for(var i=0; i < fileList.length; i++){
			formData.append('myfile', fileList[i].raw)
		}
		console.log(fileList[0].raw)
		await requestApi({method: 'POST', url: '/api/SaveImageRib/'+id, params: {}, form: formData, headers: {'Content-Type': 'multipart/form-data'}});
		try {
			let response = await requestApi({method: 'POST', url: '/api/sendInfosBank?nocache=' + new Date().getTime(), params: {}, form: {payload}, headers: {'Content-Type': 'application/json'}})
			if(response.valid){
				window.location.href = response.url
			}
		} catch (error) {
			if(error.response != undefined){
				toasterError(`${error.response.data.message}`,'Vérification')
			}else{
				toasterError(`Le service est momentanément indisponible`,'Service indisponible')
			}
		}
	} catch (error) {
		if(error.response != undefined){
			toasterError(`Impossible d'envoyer votre RIB`,'Vérification')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
	return new Promise((resolve, reject) => {
		new Vue().axios({
			method: options.method,
			url: conf.server + options.url,
			params: options.params,
			data: options.form,
			headers: options.headers,
			withCredentials: true
		}).then((response) => {
			resolve(response.data)
		}).catch((error) => {
			reject(error)
		})
	})
}

export default{
    checkBeforeSubmit,
	sendAllInfos
}

